import { core } from '@icc/shared/helpers';
import { IWindowConfiguration } from '../window-configuration';
import { DoorConfiguration } from '../door-configuration';

export function changesInVersion20(
    oldConfiguration: any,
): IWindowConfiguration {
    const configuration: IWindowConfiguration = {
        ...core.copy(oldConfiguration),
    };

    if (configuration.type === 'door') {
        (configuration as DoorConfiguration).doorHardware.outerPlates = {
            mainLock: null,
            additionalLock: null,
            color: null
        };
    }

    return configuration;
}


